var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.081,
    height: 30.82,
    viewBox: "0 0 29.081 30.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2951",
    "data-name": "Rectangle 2951",
    width: 29.081,
    height: 30.82,
    fill: "#f29b10"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hive",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29141",
    "data-name": "Path 29141",
    d: "M28.36,15.427c0,1.515.012,3.03,0,4.545a5.986,5.986,0,0,1-3.072,5.378c-2.61,1.558-5.251,3.064-7.891,4.57a6.231,6.231,0,0,1-6.667-.14q-3.53-2.08-7.1-4.1A6.459,6.459,0,0,1,.4,22.075a6.858,6.858,0,0,1-.36-2.013C0,16.949-.02,13.835.033,10.723A6.037,6.037,0,0,1,3.266,5.361C5.637,3.98,8.024,2.626,10.39,1.236A7.147,7.147,0,0,1,14.5.01a6.57,6.57,0,0,1,2.921.9c2.59,1.5,5.2,2.97,7.771,4.494a6.059,6.059,0,0,1,3.162,5.474c.01,1.515,0,3.03,0,4.545M12.48,12.668l-.048.1c-.123.006-.246.018-.369.018-1.846,0-3.692,0-5.538,0a3.684,3.684,0,0,0-3.664,2.784,3.277,3.277,0,0,0,5.25,3.439q2.822-2.4,5.621-4.834a.378.378,0,0,1,.6-.005q2.952,2.443,5.922,4.864a3.154,3.154,0,0,0,3.558.422,3.072,3.072,0,0,0,1.834-2.893,3.69,3.69,0,0,0-3.735-3.776c-1.988-.009-3.976,0-5.964,0-.133,0-.266-.019-.4-.029l-.035-.094,4.279-3.687c-.446,0-.778.02-1.106-.006a1.023,1.023,0,0,0-.8.292c-1.194,1.042-2.4,2.066-3.595,3.112a.363.363,0,0,1-.571,0q-1.919-1.6-3.856-3.187A.677.677,0,0,0,9.534,9c-.465-.022-.931-.009-1.4-.009l-.024.073,4.367,3.605m1.663,13.085c.61-.611,1.31-1.3,1.991-2a7.876,7.876,0,0,0,1.144-1.3,3.674,3.674,0,0,0,.054-3.945,3.6,3.6,0,0,0-3.427-1.876,3.575,3.575,0,0,0-3.294,2.094,3.5,3.5,0,0,0,.4,4.031,42.426,42.426,0,0,0,3.13,3m-.11-20.841c-.323.34-.573.607-.828.869s-.538.531-.8.8a2.259,2.259,0,0,0-.65,1.807A2.286,2.286,0,0,0,13.347,10.4a2.312,2.312,0,0,0,2.482-.776,2.2,2.2,0,0,0,.156-2.586c-.573-.74-1.266-1.387-1.953-2.124",
    transform: "translate(0 0)",
    fill: "#030619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29142",
    "data-name": "Path 29142",
    d: "M180.73,154.365c.146-.015.227-.03.308-.03,1.656,0,3.312-.009,4.968,0a2.233,2.233,0,0,1,2.071,2.928,1.884,1.884,0,0,1-2.893.81c-1.434-1.152-2.844-2.336-4.263-3.508a2.712,2.712,0,0,1-.192-.2",
    transform: "translate(-164.18 -140.198)",
    fill: "#030619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29143",
    "data-name": "Path 29143",
    d: "M55.517,154.992c-.113.122-.165.193-.23.248q-1.894,1.63-3.79,3.256a1.828,1.828,0,0,1-2.284.121,1.872,1.872,0,0,1-.6-2.217,2.194,2.194,0,0,1,2.145-1.432h4.346c.108,0,.216.011.408.022",
    transform: "translate(-44.034 -140.777)",
    fill: "#030619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29144",
    "data-name": "Path 29144",
    d: "M132.234,201.6a2.128,2.128,0,0,1,1.927,1.263,2.027,2.027,0,0,1-.431,2.324c-.43.456-.888.885-1.324,1.336-.127.132-.209.143-.34.007-.442-.457-.906-.893-1.342-1.356a2.037,2.037,0,0,1-.425-2.285,2.1,2.1,0,0,1,1.936-1.289",
    transform: "translate(-118.207 -183.136)",
    fill: "#030619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29145",
    "data-name": "Path 29145",
    d: "M143.048,76.987a.975.975,0,0,1-.945-.585.927.927,0,0,1,.148-1.076,7.975,7.975,0,0,1,.629-.643.281.281,0,0,1,.273,0,5.532,5.532,0,0,1,.651.661.932.932,0,0,1,.123,1.079.976.976,0,0,1-.88.567",
    transform: "translate(-128.993 -67.81)",
    fill: "#030619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHive);
export default __webpack_public_path__ + "static/media/hive.7adfe7f9a76d78d2e55b96ebfa2b4ffe.svg";
export { ForwardRef as ReactComponent };